// js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from '../common/Modal';
import Button from '../common/Button';
import { getDSAWorkflowSubmitButtonLoadingLabel } from '../../utils/createDSAWorkflowHelpers';
// css
import '../../styles/components/account/CreateDSAWorkflowTypeSelectionModal.scss';


class CreateDSAWorkflowTypeSelectionModal extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      open,
      onDismiss,
      loading,
      onCreateCustomerDSA,
      onCreateTestDSA
    } = this.props;

    const createTestDSALoadingLabel = getDSAWorkflowSubmitButtonLoadingLabel(this.props);

    return (
      <div className='assessment-modal svp-common-ui'>
        <Modal
          open={open}
          onDismiss={onDismiss}
          className='type-selection-modal'
        >
          <div className='row'>
            <div className='modal-header'>
              <h3>Select an Assessment Type</h3>
            </div>
          </div>
          <div className='row'>
            <div className='modal-content'>
              <div className='col-sm-6 type-alignment'>
                <Button
                  disabled={loading}
                  onClick={onCreateCustomerDSA}
                  label='Customer'
                  primary
                />
                <p className='text-left'>Assessments created for a Customer must be linked to an Opportunity; included in reporting and allows for full PowerPoint Output creation.</p>
              </div>
              <div className='col-sm-6 type-alignment'>
                <Button
                  loading={loading}
                  loadingLabel={createTestDSALoadingLabel}
                  onClick={onCreateTestDSA}
                  label='Practice/Test'
                  primary
                />
                <p className='text-left'>Assessments created for practice/test purposes only, allowing new user familiarization. Not intended for Customer assessments; limited reporting &amp; PowerPoint Output features.</p>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

CreateDSAWorkflowTypeSelectionModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onDismiss: PropTypes.func,
  loading: PropTypes.bool,
  onCreateCustomerDSA: PropTypes.func.isRequired,
  onCreateTestDSA: PropTypes.func.isRequired
};

export default CreateDSAWorkflowTypeSelectionModal;



// WEBPACK FOOTER //
// ./src/components/account/CreateDSAWorkflowTypeSelectionModal.js